import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWithDefaults } from "../config/fetchDefault";

export const fetchActivityThunk = createAsyncThunk(
  "scheduledCall/fetchActivity",
  async ({ agentIdNumber }, { rejectWithValue }) => {
    try {
      const response = await fetchWithDefaults(
        `/Activity?agent=${agentIdNumber}`
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();

      return {
        scheduledCalls: jsonData[0]?.scheduledCalls || [],
        appointments: jsonData[0]?.scheduled || [],
      };
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const scheduledCallSlice = createSlice({
  name: "scheduledCallInfo",
  initialState: {
    totalScheduleCall: 0,
    schedulecallArray: {
      title: "Scheduled Calls",
      data: [
        {
          Time: "",
          Name: "",
          lead_id: "",
        },
      ],
    },
    appointmentsArray: {
      title: "Appointments",
      data: [
        {
          Time: "",
          Meeting: "",
          lead_id: "",
        },
      ],
    },
    activityData: {},
  },
  reducers: {
    incrementScheduleCall: (state) => {
      state.totalScheduleCall += 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchActivityThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchActivityThunk.fulfilled, (state, action) => {
        state.status = "succeeded";

        // Process Scheduled Calls
        state.schedulecallArray.data = action.payload.scheduledCalls;

        // Process Appointments
        state.appointmentsArray.data = action.payload.appointments;

        // capture entire response from /Activity endpoint.
        // removes need for activity state variable in <App>
        state.activityData = {...action.payload}
      })
      .addCase(fetchActivityThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});
export const { incrementScheduleCall } = scheduledCallSlice.actions;

export default scheduledCallSlice.reducer;
